import { withLazyComponent } from '@document/utils/lazy-component';
import { lazy } from 'react';

export const NotFoundPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./NotFoundPage')).NotFoundPage,
  }))
);
